import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IDialogOptions, PromptDialogService } from '@lc/core';
import { BaseDialog } from '../base/base.dialog';

export interface IPdfViewerData {
  url: string;
  title?: string;
}

@Component({
  selector: 'lc-pdf-viewer',
  templateUrl: './pdf-viewer.dialog.html',
  styleUrls: ['./pdf-viewer.dialog.scss'],
  imports: [BaseDialog],
})
export class PdfViewerDialog {
  readonly data? = inject<IPdfViewerData>(MAT_DIALOG_DATA, { optional: true });
  private readonly dialogRef = inject<MatDialogRef<PdfViewerDialog, any>>(MatDialogRef, { optional: true });

  readonly safeUrl: SafeResourceUrl;
  /**
   * Opens the form as a dialog
   */
  static async open(service: PromptDialogService, data?: IPdfViewerData, options?: IDialogOptions): Promise<void> {
    const defaultOptions: IDialogOptions = { width: '80vw', height: '90vh', disableClose: false };
    const opts: IDialogOptions = Object.assign(defaultOptions, options);
    return await service.openComponent(PdfViewerDialog, data, opts);
  }

  constructor() {
    const sanitizer = inject(DomSanitizer);
    const { data } = this;

    this.safeUrl = data?.url
      ? sanitizer.bypassSecurityTrustResourceUrl(`${data.url}#toolbar=1`)
      : undefined;
  }

  onClose() {
    this.dialogRef?.close();
  }
}
